import { EntityType } from '../dictionaries/EntityType';

export class UserImage {
    SessionId: string;
    AppId: number;
    ImageSize: number;
    EntityType: EntityType;
    EntityId: number;
    Data: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user-image.ts